import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import firebase from 'firebase/app';
import 'firebase/database';
import {Editor} from '../editor-components';
import VisitorCountReport from './visitor-count-report';
import VisitorLocationReport from './visitor-locations-report';
import GiftCardPurchasesReport from './gift-card-purchases-report';

export default class ReportsList extends Component {
  /** @constructor
    * Creates a new instance of ReportsList
    */
  constructor(props){
    super(props);
    this.state = {
      expoID: props.match.params.expoID,
      showID: props.match.params.showID,
      name: ''
    }
  }

  componentWillMount() {
    firebase.database()
    .ref(`expos/${this.state.expoID}/shows/${this.state.showID}/metadata/name`)
    .on('value', (snapshot) => {
      this.setState({name: snapshot.val()});
    });
  }

  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Visitor Count</Tab>
            <Tab>Visitor Locations</Tab>
            <Tab>Gift Card Purchases</Tab>
          </TabList>
          <TabPanel>
            <VisitorCountReport name={this.state.name} expoID={this.state.expoID} showID={this.state.showID}/>
          </TabPanel>
          <TabPanel>
            <VisitorLocationReport name={this.state.name} expoID={this.state.expoID} showID={this.state.showID}/>
          </TabPanel>
          <TabPanel>
            <GiftCardPurchasesReport name={this.state.name} expoID={this.state.expoID} showID={this.state.showID}/>
          </TabPanel>
        </Tabs>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/report-list/report-list.js